export const apiErrorMessage = 'Something went wrong!'

// Otp Success Message
export const otpSendMessage = 'Otp send successfully';
export const otpErrorMessage = 'You have entered an incorrect OTP'
